import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";
import { Clock } from "lucide-react";
import api from "../lib/api";
import { TransactionRow } from "../components/TransactionRow";

const FILTERS = [
  { key: "all", label: "Semua" },
  { key: "in", label: "Masuk" },
  { key: "out", label: "Keluar" },
  { key: "pending", label: "Menunggu" },
];

export default function History() {
  const [filter, setFilter] = useState("all");
  const [txns, setTxns] = useState(null);

  useEffect(() => {
    setTxns(null);
    api.get(`/transactions?filter=${filter}&limit=100`).then((r) => setTxns(r.data)).catch(() => setTxns([]));
  }, [filter]);

  return (
    <div className="max-w-2xl mx-auto space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-semibold">Riwayat Transaksi</h1>
        <p className="text-sm text-muted-foreground">Semua aktivitas keuanganmu tercatat di sini.</p>
      </div>

      <Tabs value={filter} onValueChange={setFilter}>
        <TabsList className="grid grid-cols-4 w-full h-11 rounded-xl">
          {FILTERS.map((f) => (
            <TabsTrigger key={f.key} value={f.key} className="rounded-lg text-xs sm:text-sm" data-testid={`history-filter-${f.key}`}>
              {f.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <Card className="rounded-2xl">
        <CardContent className="p-2">
          {txns === null ? (
            <div className="space-y-3 p-4">
              {[1, 2, 3, 4, 5].map((i) => <Skeleton key={i} className="h-14 w-full rounded-xl" />)}
            </div>
          ) : txns.length === 0 ? (
            <div className="text-center py-14 px-4" data-testid="history-empty-state">
              <div className="mx-auto h-14 w-14 rounded-full bg-secondary flex items-center justify-center mb-3">
                <Clock className="h-6 w-6 text-muted-foreground" />
              </div>
              <p className="text-sm font-medium">Tidak ada transaksi</p>
              <p className="text-xs text-muted-foreground mt-1">Transaksi kamu akan muncul di sini.</p>
            </div>
          ) : (
            <div className="divide-y divide-border/60" data-testid="history-transaction-list">
              {txns.map((t) => <TransactionRow key={t.id} txn={t} />)}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
